export const DEFAULT_OBRACUN_RATES = Object.freeze({
  sunday: 0,
  holiday: 0,
  overtime: 0,
  night: 0,
});

